// DocFields — JEDNOTNÝ PANEL VSTUPNÝCH ÚDAJOV DOKLADU (ústava, Mirko 2026-07-27:
// „a hlavne ten panel o vstupných údajov musia byť v Matrix rovnaké",
//  „prečo neurobíš rovnaký dizajn — to je príkaz ústava").
//
// JEDNA definícia pre celý Matrix — CP (CenoveView), predajňová CP (PredajnaCP),
// Objednávky, Obhliadky. Keď sa má vzhľad panela zmeniť, mení sa TU a nikde inde;
// inak sa moduly časom rozídu (presne to sa stalo pred 27.7.2026).
import React from 'react'
import { COLORS, TYPO, SPACE, RADIUS } from '../theme.js'

// Jedno pole: VEĽKÝ popis hore, hodnota dole.
export function Field({ label, children }) {
  return (
    <label>
      <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginBottom: 3,
        fontWeight: TYPO.weights.semibold, textTransform: 'uppercase', letterSpacing: '0.04em' }}>{label}</div>
      {children}
    </label>
  )
}

// Rám panela — 3 stĺpce, rovnaké odsadenie a orámovanie na všetkých dokladoch.
export function FieldGrid({ children, cols = 3 }) {
  return (
    <div style={{
      padding: SPACE.md, background: COLORS.bg,
      border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md,
      display: 'grid', gridTemplateColumns: `repeat(${cols}, 1fr)`, gap: SPACE.sm,
    }}>{children}</div>
  )
}

// Jednotný štýl vstupu v paneli.
export const inp = {
  width: '100%', padding: '7px 10px',
  border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.sm,
  fontSize: TYPO.sizes.sm, background: COLORS.bg,
  fontFamily: 'inherit', boxSizing: 'border-box',
}
